export const ACCESS_TOKEN = "Access-Token";
export const TENANT = "tenant";
export const TOKEN_NAME = "token-name";
export const USER_INFO = "user";
export const USER_DETAIL = "user-detail";
